import { render, staticRenderFns } from "./SocialBar.vue?vue&type=template&id=0d76bf2f&scoped=true&"
import script from "./SocialBar.vue?vue&type=script&lang=js&"
export * from "./SocialBar.vue?vue&type=script&lang=js&"
import style0 from "./SocialBar.vue?vue&type=style&index=0&id=0d76bf2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d76bf2f",
  null
  
)

export default component.exports